"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _breakpoints = _interopRequireDefault(require("../../../../constants/breakpoints"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\ttext-align: center;\n\tfont-weight: 800;\n\n\t@media (max-width: ", ") {\n\t\tdisplay: none;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Title = _styledComponents.default.div(_templateObject(), _breakpoints.default.largeMobile);

Title.displayName = 'Title';
/** @component */

var _default = Title;
exports.default = _default;